export const surveyEndpointIds = {
    SAVE_SURVEY: 'SAVE_SURVEY',
    GET_SURVEYS: 'GET_SURVEYS',
    GET_SURVEY: 'GET_SURVEY',
    DELETE_SURVEY: 'DELETE_SURVEY',
};
